import { render, staticRenderFns } from "./HeaderIcons.vue?vue&type=template&id=a6c48248&"
import script from "./HeaderIcons.vue?vue&type=script&lang=js&"
export * from "./HeaderIcons.vue?vue&type=script&lang=js&"
import style0 from "./HeaderIcons.vue?vue&type=style&index=0&id=a6c48248&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports